module.exports = __webpack_public_path__ + "img/94031.32faaa87.svg";